<template>
	<div class="container mx-auto ">
		<div
			class="innercontent pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark"
		>
			<!-- Footer social links start -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-28"
			>
				<p
					class="text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-5"
				>
					Mein Büro
				</p>

        <iframe :style="theme === 'dark' ? 'filter: invert(90%)' : ''"  allowfullscreen="" frameborder="0" loading="lazy" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBtN1niPVYaMSzA10ewEm4qrBN6_uxKhsc&amp;q=Am+Kreuztor+2%2C+19370+Parchim&amp;zoom=18" data-bs-toggle="tooltip" data-bss-tooltip="" width="100%" height="300"></iframe>

			</div>
			<!-- Footer social links end -->

			<!-- Footer copyright start -->
			<div class="flex justify-center items-center text-center">
				<div class="text-lg text-ternary-dark dark:text-ternary-light">
					&copy; KFZ Gutachter • Michael Täuber © {{ copyrightDate }}
				</div>
			</div>

      <div
          class="pt-3 sm:pt-30 pb-8 mt-3 items-center"
      >
      <router-link
          to="/impressum"
          class="text-lg font-medium text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light  sm:mx-4 mb-2 sm:py-2 border-t-2 pt-3 sm:pt-2 sm:border-t-0 border-primary-light dark:border-secondary-dark"
          aria-label="Impressum"
      >Impressum</router-link>
        <i class="text-primary-dark dark:text-primary-light">|</i>
      <router-link
          to="/datenschutz"
          class="text-lg font-medium text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light  sm:mx-4 mb-2 sm:py-2 border-t-2 pt-3 sm:pt-2 sm:border-t-0 border-primary-light dark:border-secondary-dark"
          aria-label="Datenscutzerklärung"
      >Datenschutz</router-link>
        </div>


			<!-- Footer copyright end -->
		</div>
	</div>
</template>

<script>
import feather from 'feather-icons';
export default {
	data() {
		return {
      theme: localStorage.getItem('theme') || 'light',
			copyrightDate: new Date().getFullYear()
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},

};
</script>

<style scoped></style>
